import { render, staticRenderFns } from "./BBBMeetingUsers.vue?vue&type=template&id=48d5f6fa"
import script from "./BBBMeetingUsers.vue?vue&type=script&lang=js"
export * from "./BBBMeetingUsers.vue?vue&type=script&lang=js"
import style0 from "./BBBMeetingUsers.vue?vue&type=style&index=0&id=48d5f6fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports